import axios from "axios"
import { baseURL } from "../config/api"

export const getLocationOpenHours = (tenantId: string) => {
    return getFetch("locationOpenHour", tenantId)
}

export const getLocationOpenHour = (primaryKey: string, tenantId: string) => {
    return getFetch(`locationOpenHour/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}